import hyperdom from 'hyperdom'
import {TourOverviewTab} from '../../../defaultFlow/index.js'
import PartyPickerDayTour from './partyPickerDayTour.jsx'
import TourOverviewDayTourSchema from './tourOverviewDayTourSchema.js'
import {hotelPickupsProductCategoryIds} from 'root-config/constants.js'

export default class TourOverviewTabDayTour extends TourOverviewTab {
  constructor (options) {
    super(options)
    this.pickupLocation = this.renderPickupLocation()

    this.schema = new TourOverviewDayTourSchema({
      config: this.config,
      departure: this.departure,
    }).buildSchema()
  }

  setupPartyPicker () {
    return new PartyPickerDayTour({
      quoteCriteria: this.quoteCriteria,
      modals: this.modals,
      childrenAllowed: this.departure.childrenAllowed,
      config: this.config,
      resetExtraStays: this.extraStays.resetExtraStays.bind(this.extraStays),
      user: this.user,
      departure: this.departure,
    })
  }

  renderPickupLocation () {
    const pickupLocations = this.departure.prices.additionalProducts.filter(product => hotelPickupsProductCategoryIds.includes(product.category))
    return <div class='pickup-location'>
      <h1 className='pickup-location__header'>Pick up location</h1>
      <div className='pickup-location__content'>
        <div className='pickup-location__select'>
          <select className='pickup-location__content-picker'
            binding={{
              get: () => this.quoteCriteria.pickupLocation,
              set: location => {
                this.quoteCriteria.pickupLocation = location
                this.fieldVisited(this.quoteCriteria, 'pickupLocation')
              },
            }}>
            <option selected value={undefined}>Please select pick up location*</option>
            {pickupLocations.map(location => <option value={location} >{location.associatedProductName}</option>)}
          </select>
        </div>
        { this.renderValidationError(this.quoteCriteria, 'pickupLocation') }
      </div>
    </div>
  }

  renderInfantInfo () {
    return <div class='infant-info'>
      Infants 2 years and under travel free of charge on AAT Kings Day Tours. If you are travelling with an infant, please call our Contact Centre on <span class='infant-info-bold'>{this.config.phone.general}</span> to complete your booking
    </div>
  }

  render () {
    return <div>
      <div class="tour-overview u-clearfix" data-test="tour-overview-tab">
        {this.renderInfantInfo()}
        {this.renderPartyPickerTitle()}
        {this.renderPartyPicker()}
        {this.renderChildDatePicker()}
        {this.renderPickupLocation()}
        {this.renderAdditionalCTA()}
      </div>
    </div>
  }
}
